function evidentlyFeatures($http) {
  const getFeatures = async () => {
    const response = await $http.get('/editorial-search/features');
    return response.data;
  };
  const service = {
    features: getFeatures()
  };
  service.equalsStringValue = async (feature, value) => {
    try {
      const features = await service.features;
      return features && features[feature] && features[feature] === value;
    } catch (err) {
      return false;
    }
  };
  service.notEqualsStringValue = async (feature, value) => {
    try {
      const features = await service.features;
      return features && features[feature] && features[feature] !== value;
    } catch (err) {
      return false;
    }
  };
  return service;
}

module.exports = (ngModule) => {
  ngModule.factory('evidentlyFeatures', ['$http', evidentlyFeatures]);
};
